export default function ContactSection() {
  return (
    <section id="kontakt" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Kontaktieren Sie uns!
          </h2>
          <p className="text-xl text-gray-600">
            Wir sind für Sie da – telefonisch, per E-Mail oder WhatsApp
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Mobile Phone */}
            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-smartphone-line text-4xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Mobil</h3>
              <a 
                href="tel:015758089488" 
                className="text-2xl font-semibold text-orange-500 hover:text-orange-600 transition-colors cursor-pointer"
              >
                015758089488
              </a>
            </div>

            {/* Landline Phone */}
            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-4xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Festnetz</h3>
              <a 
                href="tel:051211772025" 
                className="text-2xl font-semibold text-orange-500 hover:text-orange-600 transition-colors cursor-pointer"
              >
                05121 1772025
              </a>
            </div>

            {/* Email */}
            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-4xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">E-Mail</h3>
              <a 
                href="mailto:info@picobellohausservice-hi.de" 
                className="text-lg font-semibold text-orange-500 hover:text-orange-600 transition-colors break-all cursor-pointer"
              >
                info@picobellohausservice-hi.de
              </a>
            </div>
          </div>

          {/* Before/After Examples */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Beispiele unserer Arbeit
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4 text-center">Vorher</h4>
                <div className="w-full h-80 rounded-xl overflow-hidden">
                  <img 
                    src="https://picobellohausservice-hi.de/wp-content/uploads/2023/06/1vorher-1024x762.png"
                    alt="Vorher - Entrümpelung"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4 text-center">Nachher</h4>
                <div className="w-full h-80 rounded-xl overflow-hidden">
                  <img 
                    src="https://picobellohausservice-hi.de/wp-content/uploads/2023/06/1nachher.png"
                    alt="Nachher - Entrümpelung"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4 text-center">Vorher</h4>
                <div className="w-full h-80 rounded-xl overflow-hidden">
                  <img 
                    src="https://picobellohausservice-hi.de/wp-content/uploads/2023/06/2vorher.png"
                    alt="Vorher - Haushaltsauflösung"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4 text-center">Nachher</h4>
                <div className="w-full h-80 rounded-xl overflow-hidden">
                  <img 
                    src="https://picobellohausservice-hi.de/wp-content/uploads/2023/06/2nachher.png"
                    alt="Nachher - Haushaltsauflösung"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}